{
  "tabs": {
    "chat": "แชท",
    "reminders": "แจ้งเตือน",
    "calendar": "ปฏิทิน",
    "settings": "ตั้งค่า"
  },
  "common": {
    "cancel": "ยกเลิก",
    "save": "บันทึก",
    "confirm": "ยืนยัน",
    "delete": "ลบ",
    "back": "กลับ",
    "close": "ปิด",
    "edit": "แก้ไข",
    "search": "ค้นหา",
    "all": "ทั้งหมด",
    "loading": "กำลังโหลด...",
    "error": "เกิดข้อผิดพลาด",
    "notFound": "ไม่พบข้อมูล",
    "tryAgain": "กรุณาลองใหม่",
    "retry": "ลองอีกครั้ง",
    "undo": "เลิกทำ",
    "pullToRefresh": "ดึงเพื่อรีเฟรช",
    "justNow": "เมื่อสักครู่"
  },
  "auth": {
    "welcome": "ยินดีต้อนรับสู่ FishMemory",
    "tagline": "ผู้ช่วยแจ้งเตือน WhatsApp ของคุณ ตอนนี้อยู่ในกระเป๋าคุณแล้ว",
    "subtitle": "ผู้ช่วยแจ้งเตือน WhatsApp ของคุณ ตอนนี้อยู่ในกระเป๋าคุณแล้ว",
    "phoneLabel": "หมายเลข WhatsApp ของคุณ",
    "phoneHint": "เราจะส่งรหัสยืนยันผ่าน WhatsApp",
    "invalidPhone": "กรุณาใส่หมายเลขโทรศัพท์ที่ถูกต้อง",
    "continue": "ดำเนินการต่อ",
    "enterPhone": "ใส่หมายเลข WhatsApp ของคุณ",
    "phonePlaceholder": "หมายเลขโทรศัพท์",
    "sendCode": "ส่งรหัส",
    "verifyTitle": "ยืนยันหมายเลขของคุณ",
    "otpSentTo": "รหัส 6 หลักถูกส่งไปที่ {{phone}} ผ่าน WhatsApp",
    "enterFullCode": "กรุณาใส่รหัส 6 หลักทั้งหมด",
    "invalidOtp": "รหัสไม่ถูกต้อง กรุณาลองใหม่",
    "otpFailed": "ส่งรหัสไม่สำเร็จ ลองใหม่อีกครั้ง",
    "otpResent": "ส่งรหัสอีกครั้งแล้ว",
    "resendIn": "ส่งซ้ำใน {{seconds}}วินาที",
    "resendCode": "ส่งรหัสอีกครั้ง",
    "enterOtp": "ใส่รหัสที่ส่งไปยัง WhatsApp ของคุณ",
    "verify": "ยืนยัน",
    "resend": "ส่งรหัสอีกครั้ง",
    "wrongNumber": "หมายเลขผิด?",
    "backToPhone": "กลับไปที่หมายเลข",
    "editPhone": "แก้ไขหมายเลขโทรศัพท์",
    "error": "ข้อผิดพลาด",
    "setupTitle": "ตั้งค่ากันเถอะ",
    "setupSubtitle": "คุณสามารถเปลี่ยนแปลงได้ในตั้งค่าทีหลัง",
    "namePlaceholder": "ชื่อของคุณ",
    "letsGo": "เสร็จสิ้นการตั้งค่า",
    "skipForNow": "ข้ามตอนนี้"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "พิมพ์ข้อความ...",
    "inputPlaceholder": "พิมพ์ข้อความ...",
    "typing": "FishMemory กำลังพิมพ์...",
    "online": "ออนไลน์",
    "connecting": "กำลังเชื่อมต่อ...",
    "reconnecting": "กำลังเชื่อมต่อใหม่...",
    "offline": "ออฟไลน์",
    "empty": "เริ่มต้นสนทนา",
    "emptyHint": "สร้างแจ้งเตือน ตรวจสอบตาราง หรือขอความช่วยเหลือ",
    "emptyAction": "ส่งตัวอย่างแจ้งเตือน",
    "actions": "ตัวเลือกแชท",
    "keep": "เก็บข้อความ",
    "clearTitle": "ล้างแชท",
    "clearConfirm": "ลบข้อความทั้งหมดในอุปกรณ์นี้? ไม่สามารถกู้คืนได้",
    "clear": "ล้างแชท",
    "optionSelected": "เลือก: {{label}}",
    "sendingSelection": "กำลังส่ง...",
    "connectionLost": "กำลังเชื่อมต่อใหม่..."
  },
  "reminders": {
    "title": "แจ้งเตือนของฉัน",
    "active": "ใช้งาน",
    "today": "วันนี้",
    "thisWeek": "สัปดาห์นี้",
    "history": "ประวัติ",
    "items": "รายการ",
    "emptyTitle": "ยังไม่มีแจ้งเตือน",
    "emptySubtitle": "สร้างจากแชทแล้วจะแสดงที่นี่",
    "emptyAction": "เปิดแชท",
    "filterActive": "ใช้งาน",
    "filterToday": "วันนี้",
    "filterWeek": "สัปดาห์นี้",
    "filterHistory": "ประวัติ",
    "emptyState": "ยังไม่มีแจ้งเตือน เริ่มแชทเลย!",
    "swipeDone": "เสร็จแล้ว",
    "swipeSnooze": "เลื่อนเวลา",
    "swipeDelete": "ลบ",
    "search": "ค้นหาแจ้งเตือน...",
    "upcoming": "กำลังจะมา",
    "completed": "เสร็จแล้ว",
    "overdue": "เกินเวลา",
    "tomorrow": "พรุ่งนี้",
    "synced": "ซิงค์ {{value}}",
    "swipeHint": "ปัดแจ้งเตือนเพื่อดูตัวเลือกเพิ่มเติม",
    "noResults": "ไม่พบแจ้งเตือนที่ตรงกับการค้นหา",
    "noResultsHint": "ลองใช้คำอื่นหรือล้างการค้นหา",
    "deleteAllFailed": "ลบแจ้งเตือนไม่สำเร็จ"
  },
  "calendar": {
    "title": "ปฏิทิน",
    "today": "วันนี้",
    "tomorrow": "พรุ่งนี้",
    "completed": "เสร็จแล้ว",
    "noEvents": "ไม่มีเหตุการณ์",
    "noEventsSubtitle": "เลือกวันที่เพื่อดูแจ้งเตือนและเหตุการณ์",
    "googleEvent": "Google Calendar",
    "legendActive": "ใช้งาน",
    "legendRecurring": "ซ้ำ",
    "legendDone": "เสร็จแล้ว",
    "legendGoogle": "Google",
    "previousMonth": "เดือนก่อนหน้า",
    "nextMonth": "เดือนถัดไป",
    "previousYear": "ปีก่อนหน้า",
    "nextYear": "ปีถัดไป",
    "goToToday": "ไปยังวันนี้",
    "all": "ทั้งหมด",
    "active": "ใช้งาน",
    "done": "เสร็จแล้ว",
    "paused": "หยุดชั่วคราว"
  },
  "settings": {
    "title": "ตั้งค่า",
    "profile": "โปรไฟล์",
    "name": "ชื่อแสดง",
    "enterName": "ใส่ชื่อของคุณ",
    "language": "ภาษา",
    "uiLanguage": "ภาษาของแอป",
    "uiLanguageHelp": "เปลี่ยน UI ปฏิทิน และทิศทางการจัดวางบนอุปกรณ์นี้เท่านั้น",
    "serverLanguage": "ภาษาการแชท",
    "serverLanguageHelp": "เปลี่ยนภาษาที่เซิร์ฟเวอร์ตอบและข้อความแจ้งเตือนสำหรับบัญชีคุณ",
    "timezone": "โซนเวลา",
    "currentTimezone": "โซนเวลาปัจจุบัน",
    "timezoneHelp": "เวลาของแจ้งเตือนทั้งหมดจะแสดงตามโซนเวลานี้",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "บันทึกโซนเวลา",
    "timezoneSaved": "อัปเดตโซนเวลาแล้ว",
    "detect": "ตรวจจับ",
    "detectFailed": "ไม่สามารถตรวจจับโซนเวลาได้",
    "autoDetect": "ตรวจจับอัตโนมัติจาก GPS",
    "notifications": "การแจ้งเตือน",
    "notificationsHelp": "แจ้งเตือนซ้ำควบคุมการแจ้งเตือนซ้ำหลังแจ้งเตือนครั้งแรก การอนุญาตแจ้งเตือนระดับอุปกรณ์จัดการในตั้งค่าโทรศัพท์",
    "pushEnabled": "แจ้งเตือนแบบพุช",
    "autoDoneOnFire": "ทำเครื่องหมายเสร็จอัตโนมัติเมื่อแจ้งเตือน",
    "autoDoneOnFireDesc": "ถ้าไม่เปิด แจ้งเตือนจะยังใช้งานจนกว่าคุณจะทำเครื่องหมายเสร็จ",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "เชื่อมต่อแล้ว",
    "googleDisconnected": "ยังไม่เชื่อมต่อ",
    "googleConnectedHelp": "แจ้งเตือนใหม่จะซิงค์กับปฏิทินโดยอัตโนมัติ",
    "googleDisconnectedHelp": "เชื่อมต่อ Google Calendar เพื่อให้แจ้งเตือนและเหตุการณ์ตรงกัน",
    "googleConnectFailed": "เชื่อมต่อ Google Calendar ไม่สำเร็จ",
    "connected": "เชื่อมต่อแล้ว",
    "disconnected": "ยังไม่เชื่อมต่อ",
    "connect": "เชื่อมต่อ",
    "disconnect": "ตัดการเชื่อมต่อ",
    "autoSync": "ซิงค์แจ้งเตือนใหม่อัตโนมัติ",
    "autosync": "ซิงค์แจ้งเตือนใหม่อัตโนมัติ",
    "subscription": "การสมัครสมาชิก",
    "trialUsed": "ทดลอง: ใช้ {{used}}/{{total}}",
    "trialStatus": "มีสิทธิ์ทดลอง",
    "activeStatus": "สมัครสมาชิกแล้ว",
    "expiredStatus": "สมัครสมาชิกหมดอายุ",
    "unsubscribedStatus": "ยังไม่ได้สมัคร",
    "about": "เกี่ยวกับ",
    "version": "เวอร์ชัน",
    "logout": "ออกจากระบบ",
    "logoutTitle": "ออกจากระบบ",
    "logoutConfirm": "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบ?",
    "noName": "ยังไม่ได้ตั้งชื่อ",
    "serverConnection": "การเชื่อมต่อเซิร์ฟเวอร์",
    "serverUrl": "URL เซิร์ฟเวอร์",
    "serverEdit": "แก้ไข",
    "saveReconnect": "บันทึกและเชื่อมต่อใหม่",
    "resetDefault": "รีเซ็ตเป็นค่าเริ่มต้น",
    "invalidServerUrlTitle": "URL เซิร์ฟเวอร์ไม่ถูกต้อง",
    "invalidServerUrlMessage": "กรอก URL เซิร์ฟเวอร์ http หรือ https ที่ถูกต้อง เช่น https://example.com",
    "uiLanguageChangeFailed": "เปลี่ยนภาษาแอปไม่สำเร็จ กรุณาลองใหม่",
    "serverLanguageChangeFailed": "เปลี่ยนภาษาแชทไม่สำเร็จ กรุณาลองใหม่",
    "timezoneChangeFailed": "เปลี่ยนโซนเวลาไม่สำเร็จ กรุณาลองใหม่",
    "autoSyncChangeFailed": "อัปเดตการซิงค์อัตโนมัติไม่สำเร็จ กรุณาลองใหม่",
    "nameChangeFailed": "อัปเดตชื่อแสดงไม่สำเร็จ กรุณาลองใหม่",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "รายละเอียดแจ้งเตือน",
    "editTime": "แก้ไขเวลา",
    "rename": "เปลี่ยนชื่อ",
    "snooze": "เลื่อนเวลา",
    "snooze15": "เลื่อน 15 นาที",
    "pause": "หยุดชั่วคราว",
    "pauseReminder": "หยุดแจ้งเตือน",
    "resume": "ดำเนินการต่อ",
    "resumeReminder": "เริ่มแจ้งเตือนใหม่",
    "skip": "ข้ามครั้งถัดไป",
    "skipOccurrence": "ข้ามครั้งนี้",
    "syncGoogle": "ซิงค์กับ Google",
    "delete": "ลบ",
    "deleteTitle": "ลบแจ้งเตือน",
    "deleteConfirm": "แจ้งเตือนนี้จะถูกลบถาวร",
    "deleteRecurringTitle": "ลบแจ้งเตือนซ้ำ",
    "deleteRecurringMessage": "คุณต้องการข้ามครั้งนี้หรือจะลบทั้งชุด?",
    "deleteThisOccurrence": "ข้ามครั้งนี้",
    "deleteEntireSeries": "ลบทั้งชุด",
    "done": "เสร็จแล้ว",
    "markDone": "ทำเครื่องหมายว่าเสร็จ",
    "undo": "กู้คืน",
    "undoPrompt": "ต้องการให้แจ้งเตือนกลับมาใช้งานอีกครั้ง? กู้คืนตอนนี้",
    "recurring": "ซ้ำ",
    "nextRun": "ครั้งถัดไป",
    "oneTime": "ครั้งเดียว",
    "pending": "รอดำเนินการ",
    "sent": "ส่งแล้ว",
    "paused": "หยุดชั่วคราว",
    "active": "ใช้งาน",
    "snoozed": "เลื่อนเวลา",
    "localTime": "แสดงตามเวลาท้องถิ่นของคุณ",
    "recurrence": "การซ้ำ",
    "created": "สร้างเมื่อ",
    "tags": "แท็ก",
    "fireCount": "จำนวนครั้งที่แจ้งเตือน",
    "actions": "ตัวเลือก",
    "none": "ไม่มี",
    "snoozeFailed": "เลื่อนแจ้งเตือนไม่สำเร็จ",
    "pauseFailed": "หยุดแจ้งเตือนไม่สำเร็จ",
    "resumeFailed": "เริ่มแจ้งเตือนไม่สำเร็จ",
    "skipFailed": "ข้ามแจ้งเตือนไม่สำเร็จ",
    "doneFailed": "ทำเครื่องหมายเสร็จไม่สำเร็จ",
    "undoFailed": "กู้คืนสถานะแจ้งเตือนไม่สำเร็จ",
    "deleteFailed": "ลบแจ้งเตือนไม่สำเร็จ",
    "rescheduleTitle": "เลื่อนเวลา?",
    "rescheduleMsg": "แจ้งเตือนนี้เกินเวลาแล้ว ต้องการเลื่อนเวลาหรือไม่?",
    "reschedule15": "ใน 15 นาที",
    "reschedule60": "ใน 1 ชั่วโมง",
    "keepOverdue": "เก็บไว้แบบเดิม"
  },
  "onboarding": {
    "slide1Title": "ยินดีต้อนรับสู่ FishMemory",
    "slide1Sub": "ผู้ช่วยแจ้งเตือนส่วนตัว — ใช้ WhatsApp และออกแบบสำหรับกระเป๋าคุณ",
    "slide2Title": "แชทได้อย่างเป็นธรรมชาติ",
    "slide2Sub": "พิมพ์แจ้งเตือนตามที่คิด: “เตือนฉันโทรหาคุณแม่พรุ่งนี้ 15:00” — เราจัดการให้",
    "slide3Title": "ไม่พลาดทุกเรื่องสำคัญ",
    "slide3Sub": "รับแจ้งเตือนตรงเวลา จัดการด้วยแท็ก และติดตามทุกเรื่องที่สำคัญ",
    "getStarted": "เริ่มเลย",
    "next": "ถัดไป",
    "firstReminderTitle": "สร้างแจ้งเตือนแรกของคุณ!",
    "firstReminderHint": "ลองพิมพ์ว่า:",
    "firstReminderExample": "เตือนฉันดื่มน้ำพรุ่งนี้ 9 โมงเช้า",
    "gotIt": "เข้าใจแล้ว!",
    "notifRationaleTitle": "ตรงต่อเวลา",
    "notifRationaleBody": "FishMemory ต้องการแจ้งเตือนเพื่อเตือนคุณตรงเวลา คุณจะได้รับแจ้งเตือนเฉพาะที่สร้างเองเท่านั้น",
    "notifRationaleAllow": "เปิดแจ้งเตือน",
    "notifRationaleLater": "ทีหลังค่อยเปิด",
    "swipeHint": "ปัดขวาเพื่อทำงานด่วน →",
    "calendarDragHint": "ลากเพื่อขยาย ↕"
  }
}
